import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { getCommonServerSideProps } from '@belong/common-nextjs-server-side-props';

import { getGlobalConfig } from 'src/components/providers/GlobalConfig';
import { DEFAULT_META } from 'src/core/constants';
import type { ISupportServerAppProps } from 'src/core/types';

export const getServerSideAppProps = async (
  context: GetServerSidePropsContext,
  requireAuthentication = false
): Promise<GetServerSidePropsResult<ISupportServerAppProps>> => {
  const appServerSideProps = await getCommonServerSideProps(context, requireAuthentication);
  if ('redirect' in appServerSideProps || 'notFound' in appServerSideProps) {
    return appServerSideProps;
  }

  const props = await appServerSideProps.props;
  const { correlationId } = props;

  const config = await getGlobalConfig(correlationId);

  const pageProps = {
    breadcrumbs: [],
    config,
    data: {},
    meta: {
      ...DEFAULT_META
    },
    ...props
  };

  return { props: pageProps };
};
